import { supabase } from "@/integrations/supabase/client";
import { handleSupabaseFunctionError } from "@/utils/supabaseFunctionsError";
import type { GetBilantParams, GetBilantResponse } from "@/api/types/bilant";

export async function getBilant(
  params: GetBilantParams
): Promise<GetBilantResponse> {
  const { data, error } = await supabase.functions.invoke(
    `api/financial-data?cui=${encodeURIComponent(params.cui)}`,
    { method: "GET" }
  );

  await handleSupabaseFunctionError(error);
  return data;
}
